<template>
  <div class="student-tutor">
    <!-- 头部 -->
    <div class="info-operation-container">
      <div class="info-search-container">
        <el-cascader v-show="activeName === '下属导师'" class="select" clearable v-model="className"
          :placeholder="classPlaceholder" :props="classProps" :options="classSelect"
          @change="changeHandle"></el-cascader>
        <!-- 搜索框 -->
        <search class="search" placeholder="请输入教师名称" @search="teacherSearch" v-show="activeName === '下属导师'" />
        <search class="search" placeholder="请输入学生名称" @search="studentSearch" v-show="activeName === '下属导师'" />
      </div>
      <div class="operation-part-container">
        <el-button type="success" size="small" @click="jumpEvaluationItem" v-hasPermi="'sc:basics:definition'">评价项目</el-button>
        <!-- <el-button type="success" size="small" @click="jumpLifeExperience">学生学习生活经历</el-button> -->
        <el-button type="success" size="small" @click="jumpStudentStatistics">记录统计</el-button>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人已绑学生" name="个人已绑学生">
          <div class="info-table-container" v-bitmap="personaListGetResult">
            <personalList class="list" :personaData="personaData" :semesterList="semesterList" :mentorTypeList="mentorTypeList"
              :classSelect="classSelect" :classProps="classProps" :classSelectList="classSelectList"
              :classPlaceholder="classPlaceholder" />
          </div>
          <!-- 学生排行-分页容器 -->
          <!-- <div class="pagination-catainer">
            <pagination :total="parseInt(personaTotal)" :pageSize="parseInt(personaPageInfo.pageSize)"
              @currentPageNumChange="currentPersonaPageNumChange" @handleSizeChange="handlePersonaSizeChange" />
          </div> -->
        </el-tab-pane>
        <el-tab-pane label="下属导师" name="下属导师">
          <div class="info-table-container" v-bitmap="listGetResult">
            <tutorList class="list" :semesterList="semesterList" :tutorList="tutorList" :mentorTypeList="mentorTypeList"
              :classSelect="classSelect" :classProps="classProps" :classSelectList="classSelectList"
              :classPlaceholder="classPlaceholder" />
          </div>
          <!-- 学生排行-分页容器 -->
          <div class="pagination-catainer">
            <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
              @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <lifeExperienceDialog v-if="lifeExperienceShow" :lifeExperienceShow.sync="lifeExperienceShow" />
    <evaluationItemDialog v-if="evaluationItemShow" :evaluateBodyList="evaluateBodyList"
      :evaluationItemShow.sync="evaluationItemShow" />
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
import tutorList from "./components/tutor-list/tutorList.vue";
import personalList from "./components/personal-list/personalList.vue";
import lifeExperienceDialog from "./components/life-experience-dialog/lifeExperienceDialog.vue";
import evaluationItemDialog from "./components/evaluation-item-dialog/evaluationItemDialog.vue";
export default {
  components: {
    search,
    tutorList,
    personalList,
    lifeExperienceDialog,
    evaluationItemDialog
  },
  data() {
    return {
      activeName: '个人已绑学生',
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "请选择班级",
      tutorList: [],
      listGetResult: "success",
      personaListGetResult: "success",
      personaData: [],
      personaTotal: 0,
      personaPageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      searchData: {
        gradeId: "",
        classId: "",
        teacherName: "",
        studentName: "",
      },
      mentorTypeList: [], // 导师类型字典
      lifeExperienceShow: false, // 学生生活经历弹窗
      evaluationItemShow: false, // 评价项目弹窗
      evaluateBodyList: [], // 评价主体字典
      semesterList: [], // 学期类型选择列表数据
    }
  },
  created() {
    // 获取年级班级
    this.selectSchoolAndGradeAndClassListPC();
    // 导师类型字典
    this.getMentorType();
    // 评价主体字典
    this.getEvaluateType();
    // 查询个人已绑定学生列表
    this.getPersonaTeacher();
    // 学期字典
    this.getSemesterType();
  },
  provide() {
    return {
      refresh: this.getSupervisingTeacher,
    };
  },
  methods: {
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterList = res.data;
      });
    },
    // 评价项目弹窗
    jumpEvaluationItem() {
      this.evaluationItemShow = true;
    },
    // 学生学习生活经历弹窗
    jumpLifeExperience() {
      this.lifeExperienceShow = true;
    },
    handleClick(tab, event) {
      if (this.activeName == "个人已绑学生") { this.getPersonaTeacher(); } else if (this.activeName == "下属导师") { this.getSupervisingTeacher(); }
    },
    // 导师类型字典
    getMentorType() {
      this.get(this.$url.getDictType + "/sc_mentor_type").then((res) => {
        // console.log("数据字典=>", res);
        this.mentorTypeList = res.data;
      });
    },
    // 评价主体字典
    getEvaluateType() {
      this.get(this.$url.getDictType + "/sc_evaluate_body").then((res) => {
        // console.log("数据字典=>", res);
        this.evaluateBodyList = res.data;
      });
    },
    // 查询个人已绑定学生列表
    getPersonaTeacher() {
      this.get(this.$url.selectTeacherStudentLinkByTeacher + "?teacherId=" + this.user.id).then(res => {
        // console.log(res);
        if (res.code != 200) return this.$message.error(res.msg);
        this.personaData = res.data;
      })
    },
    // 查询教师下属导师列表
    getSupervisingTeacher() {
      let data = {
        gradeId: this.searchData.gradeId,
        classId: this.searchData.classId,
        teacherName: this.searchData.teacherName,
        studentName: this.searchData.studentName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.get(this.$url.selectTeacherAllotByTeacher, data).then(res => {
        // console.log(res);
        if (res.code != 200) return this.$message.error(res.msg);
        this.tutorList = res.rows.map(item => {
          return item = Object.assign(item, {
            studentData: []
          })
        });
        this.total = res.total;
      })
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeId, gradeName } = gItem;
              gItem.value = {
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classId, className } = cItem;
                cItem.value = {
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 获取学生列表
            this.getPersonaTeacher();
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getSupervisingTeacher();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getSupervisingTeacher();
    },
    // 分页组件传递过来的页码修改事件
    currentPersonaPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getPersonaTeacher();
    },
    handlePersonaSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getPersonaTeacher();
    },
    changeHandle(e) {
      if (e.length) {
        this.searchData.gradeId = e[0].gradeId;
        this.searchData.classId = e[1].classId;
      } else {
        this.searchData.gradeId = "";
        this.searchData.classId = "";
      };

      if (this.activeName == "个人已绑学生") { this.getPersonaTeacher(); } else if (this.activeName == "下属导师") { this.getSupervisingTeacher(); }
    },
    teacherSearch(e) {
      this.searchData.teacherName = e;
      this.getSupervisingTeacher();
    },
    studentSearch(e) {
      this.searchData.studentName = e;
      this.getSupervisingTeacher();
    },
    jumpStudentStatistics() {
      this.$router.push({
        path: "/student-record-statistics"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./studentTutor.scss";
</style>